import { connect } from 'react-redux';
import WarehouseSelectionDialog from './WarehouseSelectionDialog';

export default connect(null, null)(WarehouseSelectionDialog);
